<template>
  <div class="home">
    <!-- Popup Image Dialog -->
    <v-dialog v-model="showImagePopup" persistent max-width="500">
      <v-card>
        <!-- <v-card-title class="text-h5">Selamat Datang!</v-card-title> -->
        <v-card-text>
          <!-- Popup Image -->
          <img
            src="../assets/halal.jpeg"
            alt="Popup Image"
            style="width: 100%; border-radius: 8px; margin-bottom: 16px"
          />
          <!-- Terima kasih telah mengunjungi situs kami. Anda dapat melacak kiriman
          Anda dengan mudah di bawah ini. -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closePopup"> Tutup </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <section class="hero">
      <div class="overlay"></div>
      <div class="hero-text container">
        <h1 class="text-h3 font-weight-bold mb-4 white--text">
          Lacak Kiriman Anda
        </h1>

        <v-card class="tracking-card mx-auto" max-width="600" elevation="5">
          <v-card-text>
            <v-form @submit.prevent="HandleClick">
              <v-text-field
                v-model="awb"
                label="Masukan No Resi / No Referensi"
                prepend-inner-icon="mdi-package-variant"
                outlined
                dense
                :loading="isLoading"
                hint="Masukkan nomor resi untuk melacak kiriman Anda"
                clearable
                @click:clear="Reset"
              ></v-text-field>

              <v-btn
                color="primary"
                block
                large
                type="submit"
                class="mt-4"
                :loading="isLoading"
              >
                <v-icon left>mdi-magnify</v-icon>
                Lacak Sekarang
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>

        <!-- Result Cards -->
        <div v-if="lacak === '1'" class="mt-6">
          <v-card class="result-card mx-auto" max-width="600" elevation="3">
            <v-card-title class="success--text">
              <v-icon left color="success">mdi-check-circle</v-icon>
              Data Ditemukan
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <p class="caption grey--text">Nomor Resi</p>
                  <p class="body-1">{{ noawb }}</p>
                </v-col>
                <v-col cols="3">
                  <p class="caption grey--text">Status</p>
                  <p class="body-1">
                    <v-chip
                      :color="getStatusColor"
                      small
                      label
                      text-color="white"
                    >
                      {{ status }}
                    </v-chip>
                  </p></v-col
                >
                <v-col cols="3">
                  <p class="caption grey--text">Keterangan</p>
                  <p class="body-1">
                    {{ ket }}
                  </p></v-col
                >
                <v-col cols="3">
                  <p class="caption grey--text">Tanggal</p>
                  <p class="body-1">
                    {{ formattedDate }}
                  </p></v-col
                >

                <v-col cols="6">
                  <p class="caption grey--text">Asal</p>
                  <p class="body-1 text-left">{{ asal }}</p>
                </v-col>
                <v-col cols="6">
                  <p class="caption grey--text">Tujuan</p>
                  <p class="body-1 text-left">{{ tujuan }}</p>
                </v-col>

                <v-col cols="3">
                  <p class="caption grey--text">Layanan</p>
                  <p class="body-1">{{ layanan }}</p>
                </v-col>
                <v-col cols="3">
                  <p class="caption grey--text">Koli</p>
                  <p class="body-1">
                    {{ pieces }}
                  </p></v-col
                >
                <v-col cols="3">
                  <p class="caption grey--text">Kg</p>
                  <p class="body-1">
                    {{ weight }}
                  </p></v-col
                >
                <v-col cols="3">
                  <p class="caption grey--text">Vol</p>
                  <p class="body-1">
                    {{ vol }}
                  </p></v-col
                >
              </v-row>
            </v-card-text>
          </v-card>
        </div>

        <div v-if="lacak === '2'" class="mt-6">
          <v-card class="result-card mx-auto" max-width="600" elevation="3">
            <v-card-title class="error--text">
              <v-icon left color="error">mdi-alert-circle</v-icon>
              Data Tidak Ditemukan
            </v-card-title>
            <v-card-text> Mohon periksa kembali nomor resi Anda </v-card-text>
          </v-card>
        </div>
      </div>
    </section>
    <!-- Our Services Section -->
    <section class="services-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-6">
            <h2 class="text-h4 font-weight-bold">Layanan Kami</h2>
          </v-col>

          <!-- Land and Sea Services -->
          <v-col cols="12" md="4">
            <v-card elevation="2" class="service-card">
              <v-img
                src="../assets/land-sea-services.jpeg"
                height="100%"
                cover
              ></v-img>
            </v-card>
          </v-col>

          <!-- Transport & Logistics -->
          <v-col cols="12" md="4">
            <v-card elevation="2" class="service-card">
              <v-img
                src="../assets/transport-logistics.jpeg"
                height="100%"
                cover
              ></v-img>
            </v-card>
          </v-col>

          <!-- Air Freight -->
          <v-col cols="12" md="4">
            <v-card elevation="2" class="service-card">
              <v-img
                src="../assets/air-freight.jpeg"
                height="100%"
                cover
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="coverage-area">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-6">
            <h2 class="text-h4 font-weight-bold">Wilayah Kerja</h2>
          </v-col>

          <!-- Head Office Info -->
          <v-col cols="12" class="text-center mb-8">
            <v-card class="head-office pa-4" color="primary" dark>
              <h3 class="text-h5 mb-2">Head Office & Warehouse:</h3>
              <p class="mb-0">Gudang CPL Perjuangan</p>
              <p class="mb-0">
                Jl. Perjuangan, Wibawa Mukti II, RT.002/RW.004,
              </p>
              <p>Jatisari, Kec. Jatiasih, Kota Bekasi, Jawa Barat 17426</p>
            </v-card>
          </v-col>

          <!-- Coverage Area Cities -->
          <v-col cols="12">
            <div class="cities-grid">
              <v-chip
                v-for="city in cities"
                :key="city"
                class="ma-2"
                color="primary"
                outlined
              >
                {{ city }}
              </v-chip>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="maps-section">
      <v-container>
        <v-row>
          <v-col cols="12" class="text-center mb-6">
            <h2 class="text-h4 font-weight-bold">Lokasi Kami</h2>
            <p class="subtitle-1 mt-2">
              Kunjungi kantor pusat kami atau hubungi tim support untuk
              informasi lebih lanjut
            </p>
          </v-col>

          <v-col cols="12">
            <v-card class="maps-card" elevation="3">
              <v-card-text class="pa-0">
                <IframeComponent :url="iframeUrl" />
              </v-card-text>

              <v-card-actions class="contact-info pa-4 bg-primary">
                <v-row align="center" justify="center">
                  <v-col cols="12" md="4" class="text-center black--text">
                    <v-icon large color="black" class="mb-2"
                      >mdi-map-marker</v-icon
                    >
                    <h3 class="text-h6 font-weight-medium mb-1">Alamat</h3>
                    <p class="mb-0">Jl. Perjuangan, Wibawa Mukti II</p>
                    <p>Bekasi, Jawa Barat 17426</p>
                  </v-col>

                  <v-col cols="12" md="4" class="text-center black--text">
                    <v-icon large color="black" class="mb-2">mdi-phone</v-icon>
                    <h3 class="text-h6 font-weight-medium mb-1">Telepon</h3>
                    <p>+62 111 8860 13</p>
                  </v-col>

                  <v-col cols="12" md="4" class="text-center black--text">
                    <v-icon large color="black" class="mb-2">mdi-email</v-icon>
                    <h3 class="text-h6 font-weight-medium mb-1">Email</h3>
                    <p>info@cplintasindo.co.id</p>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <div>
      <a :href="whatsappLink" class="whatsapp-button">
        <i class="fab fa-whatsapp"></i> Hubungi Kami di WhatsApp
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import IframeComponent from "../components/IframeComponent.vue";

export default {
  name: "HomeView",
  data() {
    return {
      isLoading: false,
      lacak: "0",
      awb: "",
      items: [],
      dialogLacak: false,
      status: "",
      noawb: "",
      ket: "",
      asal: "",
      tujuan: "",
      layanan: "",
      bukti: "",
      whatsappLink:
        "https://api.whatsapp.com/send?phone=628111886013&text=*Hai%20Admin%20Saya%20mau%20tanya%20tentang%20pengiriman%20barang%20nih%2C%20Saya%20dapat%20wa%20nya%20dari%20Web%20nya%20cplintasindo.co.id%20Terima%20kasih*",
      iframeUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.4133726130162!2d106.94405107570746!3d-6.340472662036791!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e699391fed569c3%3A0xef529c2844c542d3!2sGUDANG%20CPL%20PERJUANGAN!5e0!3m2!1sid!2sid!4v1717060093188!5m2!1sid!2sid", // Ganti dengan URL iframe yang diinginkan
      showImagePopup: true, // Control for popup image
      cities: [
        "JABODETABEK",
        "BANDUNG",
        "JAMBI",
        "MAMUJU",
        "YOGYAKARTA",
        "PALEMBANG",
        "PALU",
        "SEMARANG",
        "BANDAR LAMPUNG",
        "KENDARI",
        "SURABAYA",
        "PANGKAL PINANG",
        "MANADO",
        "DENPASAR",
        "BENGKULU",
        "GORONTALO",
        "BANDA ACEH",
        "PONTIANAK",
        "MATARAM",
        "MEDAN",
        "BANJARMASIN",
        "KUPANG",
        "PEKANBARU",
        "PALANGKARAYA",
        "AMBON",
        "BATAM",
        "BALIKPAPAN",
        "SORONG",
        "PADANG",
        "MAKASSAR",
        "JAYAPURA",
      ],
    };
  },
  components: {
    IframeComponent,
  },
  computed: {
    getStatusColor() {
      const status = this.status.toLowerCase();
      if (status.includes("diterima")) {
        return "success";
      } else if (
        status.includes("dalam pengantaran") ||
        status.includes("onboard") ||
        status.includes("persiapan") ||
        status.includes("diterima kota tujuan") ||
        status.includes("proses manifest")
      ) {
        return "info";
      } else if (status.includes("pending") || status.includes("menunggu")) {
        return "warning";
      } else if (status.includes("cancelled") || status.includes("gagal")) {
        return "error";
      }
      return "primary"; // default color
    },
    formattedDate() {
      if (!this.tanggal) return "";
      const date = new Date(this.tanggal);
      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      };
      return date.toLocaleDateString("id-ID", options);
    },
  },
  mounted() {
    // Show popup on page load
    this.showImagePopup = true;

    // Auto-dismiss popup after 5 seconds
    setTimeout(() => {
      this.showImagePopup = false;
    }, 10000); // 10000 milliseconds = 10 seconds
  },
  methods: {
    closePopup() {
      this.showImagePopup = false; // Manually close popup
    },
    async Reset() {
      this.lacak = "0";
      this.awb = "";
    },
    async HandleClick() {
      this.isLoading = true; // Mengaktifkan loader
      try {
        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",
        };
        const response = await axios.post(
          "https://woles.ptppi.co.id/api_beos/lacak.php",
          {
            awb: this.awb,
            id_perusahaan: 1,
          },
          { headers }
        );
        this.response = response.data;
        console.log(response.data.data);

        if (response.data.status === "fail") {
          this.items = [];
          this.lacak = "2";
          this.isLoading = false; // Menonaktifkan loader
        } else {
          this.noawb = response.data.data.no_pengiriman;
          this.status = response.data.data.status_pengiriman;
          this.ket = response.data.data.keterangan;
          this.asal = response.data.data.asal_kiriman;
          this.tujuan = response.data.data.tujuan_kiriman;
          this.service = response.data.data.layanan;
          this.vol = response.data.data.volume_pengiriman;
          this.weight = response.data.data.berat_pengiriman;
          this.pieces = response.data.data.koli_pengiriman;
          this.tanggal = response.data.data.tgl_status_pengiriman;
          this.layanan = response.data.data.layanan;
          this.bukti = response.data.data.bukti_penerima;
          this.lacak = "1";
          this.items = response.data.data;
          this.isLoading = false; // Menonaktifkan loader
          //localStorage.setItem("authenticated",true)
          //this.$router.push('/home')
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hero {
  background-image: url("../assets/desktop-wallpaper-logistics.jpg");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
  }

  .hero-text {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 2rem 1rem;
  }

  .tracking-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }
  }

  .result-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    animation: slideUp 0.5s ease;
    .text-left {
      text-align: left !important;
    }

    .body-1 {
      margin-bottom: 0;
    }
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.whatsapp-button {
  background-color: #25d366; /* Warna latar belakang WhatsApp */
  color: #fff; /* Warna teks */
  display: inline-block;
  padding: 10px 20px;
  border-radius: 30px; /* Untuk membuat tombol berbentuk bulat */
  text-decoration: none;
  position: fixed;
  bottom: 20px;
  right: 20px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2); /* Efek bayangan */
}

.whatsapp-button i {
  margin-right: 10px; /* Jarak antara ikon dan teks */
}

.services-section {
  padding: 60px 0;
  background: #f5f5f5;
}

.service-card {
  height: 100%;
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
  }

  .v-card-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
  }
}

.service-features {
  div {
    margin: 8px 0;
    display: flex;
    align-items: center;

    .v-icon {
      color: #4caf50;
      margin-right: 8px;
    }
  }
}

.coverage-area {
  padding: 60px 0;
  background: #ffffff;

  .head-office {
    max-width: 600px;
    margin: 0 auto;
    border-radius: 8px;

    p {
      font-size: 1.1rem;
      line-height: 1.5;
    }
  }

  .cities-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;

    .v-chip {
      font-size: 1rem;
      font-weight: 500;

      &:hover {
        transform: translateY(-2px);
        transition: transform 0.2s ease;
      }
    }
  }
}

.maps-section {
  padding: 60px 0;
  background: #f8f9fa;

  .subtitle-1 {
    color: #6c757d;
    max-width: 600px;
    margin: 0 auto;
  }

  .maps-card {
    border-radius: 8px;
    overflow: hidden;

    iframe {
      height: 450px !important;
    }

    .contact-info {
      background: linear-gradient(
        45deg,
        var(--v-primary-base),
        var(--v-primary-darken1)
      );

      .v-icon {
        opacity: 0.9;
      }

      h3 {
        font-size: 1.1rem;
      }

      p {
        opacity: 0.9;
        font-size: 0.95rem;
        line-height: 1.4;
      }
    }
  }
}
</style>

